import produce from 'immer'

const initialState = {
  clientId: '',
  tenantId: '',
}

export default (state = initialState, { type, payload }) =>
  produce(state, draft => {
    const newDraft = draft

    switch (type) {
      case '@azure/SET_CLIENT_ID': {
        newDraft.clientId = payload.clientId
        break
      }
      case '@azure/SET_TENANT_ID': {
        newDraft.tenantId = payload.tenantId
        break
      }
      default:
    }
  })
